import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConstantsService } from './api-constants.service';
import { Pagination } from '~core/models/core.models';
import {
  ValidationComputationParams,
  ValidationComputationResults,
  ValidationTransaction,
  ValidationTransationListParams
} from '~core/models/validation-transaction.models';

@Injectable()
export class ValidationTransactionService {
  private readonly _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);
  private _apiURL = this._apiConstantsService.coreManagerMicroservice;

  list(
    params?: ValidationTransationListParams
  ): Observable<Pagination<ValidationTransaction>> {
    return this._http.get<Pagination<ValidationTransaction>>(
      `${this._apiURL}/validation-transactions`,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  compute(
    payload: ValidationComputationParams
  ): Observable<ValidationComputationResults> {
    return this._http.post<ValidationComputationResults>(
      `${this._apiURL}/validation-transactions/compute`,
      payload
    );
  }
}
